<template>
    <div class="classification-popover shadow-[0px_3px_8px_0px_rgba(0,0,0,0.14)]">
        <div v-if="isLoading" class="flex items-center justify-center p-4">
            <span class="th-loading th-loading-bars th-loading-md text-gray-450" />
        </div>
        <template v-else>
            <div
                v-for="(classification, key) in classifications"
                :key="key"
                class="text-sm"
            >
                <span class="font-semibold mr-1">{{ classification.title }}</span>
                <span>{{ classification.content }}</span>
            </div>
        </template>
    </div>
</template>

<script setup lang="ts">
import { useFetchClassification } from './use-fetch-classification';

const props = defineProps<{
    type: string;
    value: string,
}>();

const {
    isLoading,
    classifications,
} = useFetchClassification(props);
</script>

<style scoped>
.classification-popover {
    padding: 8px !important;
    border-radius: 4px !important;
    @apply min-w-[300px] max-w-[500px] rounded-[5px] bg-white p-2;
}
</style>
